import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import withWidth from 'muiCompat/withWidth';
import Button from '@mui/material/Button';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import classNames from 'classnames';
import AppContext from '../../../context';
import { ModalCloseBtn } from '../../../components/statelessComponents/Buttons/ButtonsInModals';
import Attachment from '../Attachments/Attachment';
import CustomModal from '../../../components/Modals/Modal';
import messages from '../Attachments/messages';
import s from './EmbeddedAttachment.scss';
var EmbeddedAttachment = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    lesson: state.lessonDetails.lesson
  };
}), _dec3 = withWidth(), injectIntl(_class = _dec(_class = _dec2(_class = _dec3(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(EmbeddedAttachment, _React$Component);
  var _super = _createSuper(EmbeddedAttachment);
  function EmbeddedAttachment() {
    var _this;
    _classCallCheck(this, EmbeddedAttachment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    });
    return _this;
  }
  _createClass(EmbeddedAttachment, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        item = _this$props.item,
        width = _this$props.width,
        withVideo = _this$props.withVideo,
        isLast = _this$props.isLast;
      var isOpen = this.state.isOpen;
      var url = "/cloudfront/pdf-web-viewer/es5/web/viewer.html?file=".concat(encodeURIComponent("/cloudfront/".concat(item.path)));
      var iframe = /*#__PURE__*/_jsx("iframe", {
        src: url,
        className: s.iframe,
        title: item.name
      });
      if (!['xs', 'sm'].includes(width)) {
        return /*#__PURE__*/_jsx("div", {
          className: classNames(s.root, _defineProperty({}, s.last, isLast))
        }, void 0, iframe);
      }
      return /*#__PURE__*/_jsx("div", {
        className: classNames(s.root, _defineProperty({}, s.last, isLast))
      }, void 0, /*#__PURE__*/_jsx(Attachment, {
        item: item,
        withVideo: withVideo,
        actionBtn: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "rzOMtcWjM-A6KpI645KF3",
          variant: "outlined",
          color: "primary",
          size: "large",
          onClick: function onClick() {
            return _this2.toggleModal(true);
          },
          fullWidth: true
        }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.open))
      }), /*#__PURE__*/_jsx(CustomModal, {
        isOpen: isOpen,
        onClose: function onClose() {
          return _this2.toggleModal(false);
        },
        classes: {
          paper: classNames(s.modal, s.modalOverride)
        }
      }, void 0, iframe, /*#__PURE__*/_jsx(ModalCloseBtn, {
        "data-test-id": "WR04U1eJ5ZGdOCyiia633",
        fitMobileLandscapeFullWidth: true,
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      })));
    }
  }]);
  return EmbeddedAttachment;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  width: '',
  isLast: false
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class);
export { EmbeddedAttachment as default };